import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResponseListRoutingModule } from './response-list-routing.module';
import { ResponseListCardComponent } from './response-list-card/response-list-card.component';
import { ResponseListComponent } from './response-list.component';
import { SharedModule } from '@shared/shared.module';
import { MatDatepickerModule } from '@angular/material/datepicker';


@NgModule({
  declarations: [
    ResponseListCardComponent,
    ResponseListComponent,
  ],
  imports: [
    CommonModule,
    ResponseListRoutingModule,
    SharedModule,
    MatDatepickerModule,
  ]
})
export class ResponseListModule { }
